export const emptyLiquidationTransaction =
  [{
    "id": "",
    "txtime": 0, 
    "tx": "", 
    "liquidator": "",
    "borrower": "",
    "seize_token": "", 
    "repay_token": "", 
    "seize_amount": 0,
    "repay_amount": 0,
    "seize_usdvalue": 0,
    "repay_usdvalue": 0, 
    "treasury_amount": 0, 
    "treasury_usdvalue": 0
  }];

/* example
{"id": "e1f4fdd75c21",
"txtime": 1677238596, 
"tx": "0x49305523ace4af0abacd694bc3b426e52fed04e6dfc0562879ea6082c6736bc4", 
"liquidator": "0x8ea5a7223768357f387ab073b82352dfbcba335d",
"borrower": "0xec611d044232f9215bce3986cd94bd3d8da47993",
"seize_token": "BTCB", 
"repay_token": "BUSD", 
"seize_amount": 0.00596234427131151,
"repay_amount": 128.87105256657125,
"seize_usdvalue": 142.03718301456968,
"repay_usdvalue": 128.8581654613146, 
"treasury_amount": 0.00027101564869597773, 
"treasury_usdvalue": 6.456235591571349}
*/